// extracted by mini-css-extract-plugin
export var searchHeader = "_1t-0";
export var searchHeaderDark = "_1t-1";